<template>
  <button
    type="button"
    class="btn sso-btn"
    @click="msalLogin">
    Microsoft Azure-Login
  </button>
</template>

<script>
import * as Sentry from '@sentry/vue';
import { msal } from '@/utility';

export default {
  name: 'SsoLogin',
  computed: {
    getMsalCredentials() {
      return this.$store.getters.bootstrap?.settings?.availableFeatures?.azureSSO;
    },
  },
  methods: {
    msalLogin() {
      // if credentials are not correct, and if user set correct credentials
      // msal.interaction.status still persist in sessionStorage, so we need to remove it,
      // so user can login again
      if (sessionStorage.getItem('msal.interaction.status')) {
        sessionStorage.removeItem('msal.interaction.status');
      }
      msal.loginPopup(this.getMsalCredentials).then((res) => {
        const { idToken } = res;
        this.$store.dispatch('auth/msalLogin', { idToken }).then(() => {
          const { redirect } = this.$route.query;
          this.$router.push(redirect || '/');
        }).catch(this.showResponseError);
      }).catch((error) => {
        // Dont' show error message if user cancelled the login
        if (error.errorCode !== 'user_cancelled') {
          Sentry.captureException(error);
          this.$notify.danger(this.$options.filters.translate('admin_msal_login_failed'));
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sso-btn {
  margin-left: 16px;
  background: $color-back-basic;
  color: $color-text-primary;
}
</style>
